export enum SensorsRoutesEnum {
  LIST = '',
  BATCH_CREATE = 'create/batch',
  EDIT = 'edit/:sensorId',
}
